<template>
    <div :class="[isMobile ? 'mobile' : 'desktop','do-this-container']">
      <section id="understandingYouConfirmation" class="container is-fluid">
        <div v-html="benefits" class="benefits">
        </div>
        <div v-html="whatYouNeed" :class="['what-you-need', isRetiredMember || ftQualifiedIn2025 ? 'no-pli-displayed' : '']">
        </div>
        <div class="confirm">
          <div>We just need a few more details about you...</div>
          <button v-on:click.stop.prevent="confirm" type="button" v-if="benefitsRetrieved">Continue your application ></button>
          <div v-else>There has been an issue retrieving the benefits</div>
        </div>
        </section>
    </div>
</template>

<script>
import api from '@/api';
import '@/styles/confirmation.scss';
import { mapGetters } from 'vuex';
import Mobile from '../mobile/mobile';
import Manager from '../applicationManager';
import Store from '../store';

export default {
  name: 'Confirmation',
  data() {
    return {
      benefits: '',
      whatYouNeed: '',
      isMobile: this.$store.state.isMobile,
      benefitsRetrieved: true,
    };
  },
  mounted() {
    if (this.isMobile) {
      Mobile.initSections(this.$el);
    }
    this.fetchBenefits();
  },
  computed: {
    ...mapGetters(['isRetiredMember', 'ftQualifiedIn2025']),
  },
  methods: {
    async confirm() {
      if (Store.getters.isLoggedIn) {
        this.$emit('saveInProgress', true);

        const result = {
          successful: true,
          message: 'Application saved successfully',
        };

        try {
          await Manager.createApplication(Store.getters.application.UserInfo.userId);
        } catch (e) {
          result.successful = false;
          result.message = 'There has been a problem managing the application. Please contact the membership team';
        }

        this.$emit('completed', { message: result.message, successful: result.successful });
      } else {
        this.$emit('completed');
      }
    },
    async fetchBenefits() {
      const response = await api.getMembershipBenefits(this.$store.state.application.Type);
      if (response.status !== 200) {
        this.benefitsRetrieved = false;
      }
      const benefitsAndNext = response.data || { };
      if (benefitsAndNext.editorBenefitData) {
        this.benefits = decodeURIComponent(benefitsAndNext.editorBenefitData);
      }
      if (benefitsAndNext.editorWhatYouNeedData) {
        this.whatYouNeed = decodeURIComponent(benefitsAndNext.editorWhatYouNeedData);
      }
    },
  },
};
</script>
<style lang="scss">
  @import '../styles/_mixins.scss';
  .no-pli-displayed li:first-child {
    display: none;
  }
</style>
